import { IEvent } from "../types/Event";

export default function convertStartEndToMinutes(event: IEvent | Omit<IEvent, "id" | "isInturruption" | "owner">){
    let eventStartMinutes = ((event.startDay + (event.startWeek * 7)) * (24 * 60)) + (parseInt(event.start.split(":")[0]) * 60) + (parseInt(event.start.split(":")[1]));
    let eventEndMinutes = ((event.endDay + (event.endWeek * 7)) * (24 * 60)) + (parseInt(event.end.split(":")[0]) * 60) + (parseInt(event.end.split(":")[1]));
    return [eventStartMinutes, eventEndMinutes]
}